import { PhosphorGlobe } from "components/Atoms/PhosphorIcon";
import React from "react";
import { Input } from "semantic-ui-react";

const JsonApiUrlInput = (props: { url: string }) => <div className="margin-bottom-mini">
  <Input
    label={<div className="ui label basic copy-to-clipboard-button" onClick={(e) => {
      e.preventDefault();
      window.open(props.url, "_blank");

    }}>
      <PhosphorGlobe />
    </div>}
    labelPosition="right"
    fluid
    value={props.url}
  />
</div>;

export default JsonApiUrlInput;